import { getTargetPosition, getTransformOrigin, Rect, suitBorder, } from './PopoverPositionUtils';
/**
 * 计算Popover位置的几何模型实现
 */
var PopoverPosition = /** @class */ (function () {
    /**
     * 创建计算popover位置的PopoverPosition对象。
     *
     * @param {*} anchorPosition 定位的相对位置
     * @param {*} transformPosition 偏移的相对位置（由css3的transform-origin实现）
     * @param {*} marginThreshold 与容器的边距
     */
    function PopoverPosition(anchorPosition, transformPosition, marginThreshold) {
        this.anchorPosition = anchorPosition;
        this.transformPosition = transformPosition;
        this.marginThreshold = marginThreshold;
    }
    /**
     * 获取popover的位置
     *
     * @param {*} containerRect 容器尺寸
     * @param {*} anchorRect 相对定位的锚点
     * @param {*} targetRect 需要定位的目标
     * @param {number} targetAnchorOffset 目标定位的偏移量
     */
    PopoverPosition.prototype.getPosition = function (containerRect, anchorRect, targetRect, targetAnchorOffset) {
        var targetPosition = getTargetPosition(anchorRect, this.anchorPosition);
        var targetOffset = getTransformOrigin(targetRect, targetAnchorOffset, this.transformPosition);
        // 如果有指定的AnchorOffset，就相当于将指定的定位元素放置在anchor元素的中间位置
        if (targetAnchorOffset > 0) {
            targetOffset.vertical -= anchorRect.height / 2;
        }
        return suitBorder(new Rect(targetRect.width, targetRect.height, targetPosition.left - targetOffset.horizontal, targetPosition.top - targetOffset.vertical), targetOffset, containerRect, this.marginThreshold);
    };
    return PopoverPosition;
}());
export default PopoverPosition;
//# sourceMappingURL=PopoverPosition.js.map